import { render, staticRenderFns } from "./user-setting.vue?vue&type=template&id=ad3d5b10&scoped=true"
import script from "./user-setting.vue?vue&type=script&lang=ts"
export * from "./user-setting.vue?vue&type=script&lang=ts"
import style0 from "./user-setting.vue?vue&type=style&index=0&id=ad3d5b10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3d5b10",
  null
  
)

export default component.exports